<template>
    <template v-if="userInfo.id">
        <div class="inline-block rel" @click.stop>
            <div class="abs r:20 bg:white box-shadow:0|0|20|0|#0000001A bottom:50% right:100% mr:10 mb:0 translateY(75%) z:1" v-if="menu.isOpen()">
                <div class="
                    rel p:16 r:20
                    {content:'';abs;bg:url(image/arrow_tooltip.svg);bottom:75%;right:-6;w:12;h:6;mb:-6;mr:0;transform-origin:50%|0;rotate(-90deg)}::after
                    {w:100;b:0;p:8|16;inline-flex;ai:center;gap:8;white-space:nowrap}>button
                    {r:12;bg:#F8F8F8}>button:hover
                ">
                    <template v-if="isOwner">
                        <button @click="setTop(true)" type="button" v-if="top === false">置頂話題</button>
                        <button @click="setTop(false)" type="button" v-else-if="top">取消置頂</button>
                    </template>
                    <button @click="global.openTopicEditorById(topicId)" type="button" v-if="editable">編輯話題</button>
                    <button @click="doDelete" type="button" v-if="editable || isOwner">刪除話題</button>
                    <button @click="doInform" type="button" v-else>檢舉</button>
                </div>
            </div>
            <button class="inline-flex ai:center jc:center" :class="`w:${size}`" @click="menu.toggle(true)" type="button">
                <i class="fa-solid fa-ellipsis-vertical color:#5E6472" :class="`f:${size}`"></i>
            </button>
        </div>
        <topic-remove-modal @remove="emit('remove')" ref="removeModal" v-if="editable || isOwner"></topic-remove-modal>
        <topic-inform-modal ref="informModal" v-else></topic-inform-modal>
    </template>
</template>

<script setup>
    const menu = new ToggleStore().toggler(Symbol("_menu_comment"));
    const global = useGlobal();
    const userInfo = useUserInfo();

    const informModal = ref();
    const removeModal = ref();

    const editable = computed(() => props.memberId === userInfo.id);
    const isOwner = computed(() => userInfo.parts?.includes(props.partId));

    const props = defineProps({
        memberId: { required: true, type: Number },
        partId: { required: true, type: Number },
        size: { default: 18, type: Number },
        top: {},
        topicId: { required: true, type: Number }
    });

    const doDelete = () => {
        menu.toggle(true);
        removeModal.value.show(props.topicId);
    };

    const doInform = () => {
        menu.toggle(true);
        informModal.value.show(props.topicId);
    };

    const emit = defineEmits(["remove", "top"]);

    const setTop = (top) => {
        api("api/topic/top", { topic_id: props.topicId, top }).done((res) => {
            if (res.success) {
                emit("top", props.topicId, res.top);
                menu.toggle();
            }
        });
    };

    userInfo.init();
</script>
